import React from 'react';

import type TIconIds from 'bz-icons/src/common/type/icon-ids';

export interface IProps {
  id: TIconIds;
  load: (id: TIconIds) => void;
}

const LoadHelper: React.FC<IProps> = React.memo(({ id, load }) => {
  React.useEffect(() => {
    load(id);
  }, [id, load]);

  return null;
});

LoadHelper.displayName = 'LoadHelper';

export default LoadHelper;
